import { createFileRoute } from '@tanstack/react-router';
import { JourneysWorkflowHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateWorkflowCanvasSearch } from './-workflow-canvas-search';

/**
 * `/journeys/automations/:campaignId/overview/workflow/actions` — the Workflow tab's address on a
 * campaign past the draft state. Flag off it renders the embedded host; flag on it forwards to
 * the migrated URL.
 *
 * `appBundle` belongs here for the same reason as on the setup URL: this URL keeps the
 * `journeys` segment the sentinel resolver rebuilds targets from.
 */
function JourneysAutomationsOverviewWorkflowActionsRoute() {
  const { campaignId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWorkflowHandoff campaignId={campaignId} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions',
)({
  component: JourneysAutomationsOverviewWorkflowActionsRoute,
  validateSearch: validateWorkflowCanvasSearch,
});
